import { LegendDropdownMenuWrapper } from './styles';
import { Button, CheckBox, Icon } from '../../Universal/NovusDSImports';
import {
  btnStyles,
  checkBoxStyles
} from '../../Universal/NovusDSImports/variants';
import {
  // activeRoadwork,
  camera,
  construction,
  incidents,
  mileposts,
  restFacilities,
  specialEvents
} from '../../Universal/Assets';
import { STRINGS } from '../../Constants/ConstantStrings';
import { TooltipComponent } from '../../SharedComponets/Tooltip';

interface FilterDropdownProps {
  checkedItems: any;
  setCheckedItems: any;
  setIsLegendDropDown: any;
  isDropdownHeight?: any;
  handleLayerToggle: (boolean, string) => void;
  handleClear: any;
}

export default function LegendDropdownMenu(props: FilterDropdownProps) {
  const {
    checkedItems,
    setCheckedItems,
    setIsLegendDropDown,
    handleLayerToggle,
    handleClear
  } = props;

  const handleItemClick = (key) => {
    setCheckedItems((prevState) => {
      if (key === 'mileposts') {
        handleLayerToggle(!prevState[key], 'mileposts');
      }
      return {
        ...prevState,
        [key]: !prevState[key]
      };
    });
  };

  const ptcListItems = [
    { key: 'cameras', icon: camera, label: 'Cameras' },
    { key: 'mileposts', icon: mileposts, label: 'Mileposts' }
  ];

  const penndotListItems = [
    { key: 'incidents', icon: incidents, label: 'Incidents' },
    { key: 'construction', icon: construction, label: 'Active Roadwork' },
    { key: 'specialEvents', icon: specialEvents, label: 'Special Events' },
    // { key: 'activeRoadwork', icon: activeRoadwork, label: 'Active Roadwork' },
    { key: 'restFacilities', icon: restFacilities, label: 'Rest Facilities' }
  ];

  return (
    <LegendDropdownMenuWrapper
      isDropdownHeight={props.isDropdownHeight}
      data-testid="legend-dropdown-menu"
    >
      <div className="dropdown-menu-header">
        {STRINGS.LEGENDS}
        <div className="d-flex align-items-center justify-content-between gap-1">
          {Object.values(checkedItems).includes(true) ? (
            <div
              tabIndex={0}
              aria-disabled={!Object.values(checkedItems).includes(true)}
            >
              <Button
                {...btnStyles.dangerTertiary}
                data-testid="clear-all-button"
                onClick={handleClear}
                tabIndex={0}
                aria-label="clear-all-selected-legend-filters"
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    handleClear();
                  }
                }}
                disabled={!Object.values(checkedItems).includes(true)}
              >
                {STRINGS.CLEAR_ALL}
              </Button>
            </div>
          ) : null}
          <div
            role="button"
            className="close-icon"
            tabIndex={0}
            data-tooltip-id="close-legend-dropdown"
            aria-label="close legend dropdown menu"
            data-testid="close-icon"
            onClick={() => setIsLegendDropDown(false)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                setIsLegendDropDown(false);
              }
            }}
          >
            <Icon icon="close" width={18} height={18} />
          </div>
          <TooltipComponent
            id="close-legend-dropdown"
            place="bottom-end"
            noArrow
          >
            {STRINGS.CLOSE}
          </TooltipComponent>
        </div>
      </div>
      <div className="dropdown-body-section">
        <div className="gap-1 d-flex flex-column">
          <h3 tabIndex={0}>{STRINGS.PA_TURNPIKE}</h3>
          <ul>
            {ptcListItems.map((item) => (
              <li
                key={item.key}
                data-testid={`${item.label.toLowerCase()}-item`}
                aria-label={item.label}
                role="option"
                className={checkedItems[item.key] && 'selected-list'}
              >
                <CheckBox
                  onClick={() => handleItemClick(item.key)}
                  tabIndex={0}
                  {...checkBoxStyles}
                  id={`${item.key}-checkbox`}
                  role="checkbox"
                  data-testid={`${item.label.toLowerCase()}-checkbox`}
                  selected={checkedItems[item.key]}
                  text={
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={item.icon}
                        aria-hidden={true}
                        alt={`${item.key} - logo`}
                        loading="lazy"
                      />
                      <p className="legend-label">{item.label}</p>
                    </div>
                  }
                />
              </li>
            ))}
          </ul>
        </div>
        <div className="gap-1 d-flex flex-column">
          <h3 tabIndex={0} aria-label="">
            {STRINGS.PENNDOT}
          </h3>
          <ul>
            {penndotListItems.map((item) => (
              <li
                key={item.key}
                data-testid={`${item.label.toLowerCase()}-item`}
                aria-label={item.label}
                role="option"
                className={checkedItems[item.key] && 'selected-list'}
              >
                <CheckBox
                  id={`${item.key}-checkbox`}
                  data-testid={`${item.label.toLowerCase()}-checkbox`}
                  role="checkbox"
                  tabIndex={0}
                  onClick={() => handleItemClick(item.key)}
                  text={
                    <div className="d-flex align-items-center gap-2">
                      <img
                        aria-hidden="true"
                        src={item.icon}
                        alt={item.icon}
                        loading="lazy"
                      />
                      <p className="legend-label">{item.label}</p>
                    </div>
                  }
                  {...checkBoxStyles}
                  selected={checkedItems[item.key]}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </LegendDropdownMenuWrapper>
  );
}
